module.exports = [{"id":1,"image":"school-5.jpg","school_type":"Lower School (K-IV)","school":"Camestone School"},{"id":2,"image":"school-6.jpg","school_type":"Middle School (V-VIII)","school":"Cotton End Forest School"},{"id":3,"image":"school-7.jpg","school_type":"Upper School (VIII-XII)","school":"Cotton End Forest School"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/featuredschool.json
// module id = UmvD
// module chunks = 1